import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/areaAction";
import * as uiHelpers from "../AreaUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption,
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useAreaUIContext } from "../AreaUIContext";
import { RoleChecker } from "../../../../RoleChecker";
import DeleteModal from "../DeleteModal/DeleteModal";
import { toast } from "react-toastify";
// import { ToastContainer } from 'react-toastify';

const AreaTable = (props) => {
  // Area UI Context
  const areaUIContext = useAreaUIContext();
  const areaUIProps = useMemo(() => {
    return {
      queryParams: areaUIContext.queryParams,
      setQueryParams: areaUIContext.setQueryParams,
      openEditAreaPage: areaUIContext.openEditAreaPage,
    };
  }, [areaUIContext]);

  // Getting curret state of area list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.area }),
    shallowEqual
  );

  // * MODAL
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentArea, setCurrentArea] = useState({});
  const deleteArea = () => {
    dispatch(actions.deleteArea(currentArea.uuid)).then((res) => {
      toast.success(res.message, toastOption);
      setDeleteModal(false);
      setCurrentArea({});
      dispatch(actions.fetchAreas(areaUIProps.queryParams));
    });
  };

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(actions.fetchAreas(areaUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areaUIProps.queryParams, dispatch]);

  const allowEdit = RoleChecker("Edit", "wilayah");
  const allowDelete = RoleChecker("Delete", "wilayah");

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Nama",
      sort: true,
    },
    {
      dataField: "thk_period.name",
      text: "Periode",
      sort: true,
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditAreaPage: areaUIProps.openEditAreaPage,
        allowEdit,
        allowDelete,
        setCurrentArea,
        setDeleteModal,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px",
      },
    },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: areaUIProps.queryParams.pageSize,
    page: areaUIProps.queryParams.pageNumber,
  };

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onHide={() => {
          setDeleteModal(false);
          setCurrentArea({});
        }}
        onClick={deleteArea}
        title="Hapus Wilayah"
        content={`Apakah kamu yakin ingin menghapus wilayah ${currentArea.name}?`}
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  areaUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default AreaTable;
